import { render, staticRenderFns } from "./tableToolsWrap.vue?vue&type=template&id=ffbf4806&"
import script from "./tableToolsWrap.vue?vue&type=script&lang=js&"
export * from "./tableToolsWrap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports